import { AppHelper } from "../appHelper";
import { AppBaseProps, CommonApp, Context, Entity, Metadata } from "../core/components/commonApp";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { Grid } from "../core/components/grid";
import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { DialogHelper } from "../core/util/dialogHelper";
import React from "react";
export default class AbsenceOverviewApp extends React.Component<AbsenceOverviewAppProps, AbsenceOverviewAppState> {
    common = new AppHelper();
    absenceGridOptions: {};
    annualVacationGridOptions: {};
    trannslations: {};

    constructor(props) {
        super(props);
        this.common.init(this);
        this.trannslations= props.metadata.additional.objects.filter(o => o.name == "translations")[0].data;
        this.state = {
            absenceGridData: null,
            annualVacationGridData: null,
            selectedAbsense: null,
            year: new Date().getFullYear(),
            filter: this.props.entity
        }
    }

    componentDidMount() {
        this.setAbsenceGridData();
        this.props.entity.ShowStornoAction = false;
    }

    private setAbsenceGridData() {
        HTTPService.post<JsonResultClass<AbsenceViewModel>>("AbsenceOverview/GetAbsenceViewModels", this.state.filter)
            .then((result) => {
                if (result.Code == 0)
                    this.setState({ absenceGridData: result.Data })
                else 
                    NotificationHelper.showErrorMessage(result.Message)
            });
    }

    storno = () => {
        let start = this.state.selectedAbsense.Start;
        let end = this.state.selectedAbsense.End;
        let kennung = this.state.selectedAbsense.Kennung;
        let message = this.trannslations["WebSMS.FlexTime.WirklichStornieren"] + kennung + ": " + moment(start).format("DD.MM.YYYY") + " - " + moment(end).format("DD.MM.YYYY");
        this.dialogQuestion(message, () => {
        HTTPService.post<JsonResultClass>("AbsenceOverview/Storno?projNr=" + this.state.selectedAbsense.Projnr + '&pIndex=' + this.state.selectedAbsense.PIndex)
            .then((result) => {
                if (result.Code == 0) {
                    this.setAbsenceGridData();
                    this.setState({});
                }
                else
                    NotificationHelper.showErrorMessage(result.Message);
            });
        })
    }

    private dialogQuestion = async (question: string, action) => {
        const isOk = await DialogHelper.confirm(question);
        if (isOk)
            action();
    }

    renderAbsenceGrid = () => {
        if (!Helper.hasValue(this.state.absenceGridData))
            return null;
        const content = <div style={{ height: "400px" }}> <Grid data={this.state.absenceGridData} options={this.absenceGridOptions} id="absenceGrid"
            onSelectionChanged={(dataItem: AbsenceViewModel) => { this.onSelecetionChanged(dataItem) }} />
        </div>
        return (content);
    }

    onSelecetionChanged = (dataItem: AbsenceViewModel) => {
        let showStornoFirstGenehm = dataItem != null && dataItem.CusGenehm != 2 && (dataItem.Bemerkung2 == AbsenceState.Approved || dataItem.Bemerkung2 == AbsenceState.ApprovedAndEmailSend);
        let showStornoSecondGenehm = dataItem != null && (dataItem.Bemerkung2 == AbsenceState.ApprovedSecond || dataItem.Bemerkung2 == AbsenceState.ApprovedAndEmailSendSecond);
        this.props.entity.ShowStornoAction = showStornoFirstGenehm || showStornoSecondGenehm; 
        this.setState({ selectedAbsense: dataItem });
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.Start":
                this.handleFilterChange(field, value);
                break;
            case "entity.End":
                this.handleFilterChange(field, value);
                break;
            case "entity.Knrs":
                this.handleFilterChange(field, value);
                break;
            case "entity.ShowCanceled":
                this.handleFilterChange(field, value);
                break;
        }

        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
        this.common.setEntityDirtyState(false);
    }

    handleFilterChange(field: { model: string }, value) {
        var filter = this.state.filter;
        switch (field.model) {
            case "entity.Start":
                filter.Start = value;
                this.setState({ filter: filter });
                break;
            case "entity.End":
                filter.End = value;
                this.setState({ filter: filter });
                break;
            case "entity.Knrs":
                filter.Knrs = value;
                this.setState({ filter: filter });
                break;
            case "entity.ShowCanceled":
                filter.ShowCanceled = value;
                this.setState({ filter: filter });
                break;
        }
        this.setAbsenceGridData();
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return (<CommonApp {...props} />);
    }
}

export interface AbsenceOverviewAppProps extends AppBaseProps {
    entity: AbsenceOverviewEntity;
    title: string;
    metadata: Metadata;
    context: AbsenceOverviewContext;
}

export interface AbsenceOverviewContext extends Context {
    absenceGridOptions?: {}
}

export interface AbsenceOverviewAppState {
    year: number;
    absenceGridData: {};
    annualVacationGridData: {};
    selectedAbsense: AbsenceViewModel;
    filter: AbsenceOverviewEntity;
}

export interface AbsenceOverviewEntity extends Entity {
    RessNr: string;
    Start: Date;
    End: Date;
    Knrs: number[];
    ReadOnly: boolean;
    ShowCanceled: boolean;
    ShowStornoAction: boolean;
    Planned: boolean;
}

export interface AbsenceViewModel extends Entity {
    Projnr: string;
    PIndex: number;
    Days: number;
    Approved: boolean;
    HalfDay: boolean;
    Knr: number;
    Kennung: string;
    Start: Date;
    End: Date;
    Storno: boolean;
    Bemerkung: string;
    Bemerkung2: string;
    CusGenehm: number;
}

const AbsenceState = {
    CancelledRefused: "-2",
    CancelledRequest: "-1",
    CancelledRequestAndEmailSend: "-0",
    Requested: "0",
    Approved: "2",
    Refused: "3",
    ApprovedSecond: "4",
    RefusedSecond: "5",
    ApprovedAndEmailSend: "Done",
    ApprovedAndEmailSendSecond: "DoneSecond"
}